/*
 * Maria Elena Headpieces — Collection category selector
 * Shared by sections/meh-collection-hero.liquid and sections/meh-collection-grid.liquid
 *
 * Deep links (emails, ads, Instagram): /collections/between-shadows?piece=earrings
 * Note: "?view=" is reserved by Shopify for alternate templates, so we use "?piece=".
 */
(function () {
  'use strict';

  var PARAM = 'piece';
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Shared state ---------- */
  if (!window.MehCollectionFilter) {
    var subs = [];
    var defSubs = [];

    window.MehCollectionFilter = {
      state: { key: 'all', match: 'all', value: '', label: '' },
      defs: [],

      set: function (def, opts) {
        opts = opts || {};
        this.state = Object.assign({ key: 'all', match: 'all', value: '', label: '' }, def);
        var state = this.state;
        subs.slice().forEach(function (fn) { fn(state, opts); });
        if (opts.updateUrl !== false) this.writeUrl();
      },

      subscribe: function (fn) {
        subs.push(fn);
        fn(this.state, { initial: true });
        return function () { subs = subs.filter(function (f) { return f !== fn; }); };
      },

      setDefs: function (defs) {
        this.defs = defs;
        defSubs.slice().forEach(function (fn) { fn(defs); });
      },

      onDefs: function (fn) {
        defSubs.push(fn);
        fn(this.defs);
        return function () { defSubs = defSubs.filter(function (f) { return f !== fn; }); };
      },

      find: function (key) {
        for (var i = 0; i < this.defs.length; i++) if (this.defs[i].key === key) return this.defs[i];
        return null;
      },

      readUrl: function () {
        try { return new URL(window.location.href).searchParams.get(PARAM); } catch (e) { return null; }
      },

      writeUrl: function () {
        try {
          var url = new URL(window.location.href);
          if (this.state.key === 'all') url.searchParams.delete(PARAM);
          else url.searchParams.set(PARAM, this.state.key);
          window.history.replaceState(window.history.state, '', url.toString());
        } catch (e) {}
      }
    };
  }

  var F = window.MehCollectionFilter;

  function scrollToGrid() {
    var grid = document.querySelector('meh-collection-grid');
    if (!grid) return;
    var top = grid.getBoundingClientRect().top;
    if (top > window.innerHeight * 0.55 || top < 0) {
      grid.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
    }
  }

  function centerInRow(row, el) {
    if (!row || !el || row.scrollWidth <= row.clientWidth) return;
    var left = el.offsetLeft - row.clientWidth / 2 + el.clientWidth / 2;
    row.scrollTo({ left: left, behavior: reduceMotion ? 'auto' : 'smooth' });
  }

  /* ---------- Hero: owns the categories ---------- */
  if (!customElements.get('meh-collection-hero')) {
    customElements.define('meh-collection-hero', class extends HTMLElement {
      connectedCallback() {
        var self = this;
        this.chips = Array.prototype.slice.call(this.querySelectorAll('[data-meh-chip]'));
        this.row = this.querySelector('.meh-ch__chips');

        this.onClick = function (e) {
          if (e.target.closest('[data-meh-scroll]')) { scrollToGrid(); return; }
          var chip = e.target.closest('[data-meh-chip]');
          if (!chip || !self.contains(chip)) return;
          var def = F.find(chip.dataset.key);
          if (!def) return;
          F.set(def, { source: 'hero' });
          centerInRow(self.row, chip);
          if (self.dataset.scrollToGrid === 'true') scrollToGrid();
        };
        this.addEventListener('click', this.onClick);

        if (this.chips.length) {
          F.setDefs(this.chips.map(function (c) {
            return { key: c.dataset.key, match: c.dataset.match, value: c.dataset.value, label: c.dataset.label };
          }));

          this.unsub = F.subscribe(function (state) {
            self.chips.forEach(function (c) { c.setAttribute('aria-pressed', String(c.dataset.key === state.key)); });
          });

          var fromUrl = F.readUrl();
          if (fromUrl && F.find(fromUrl)) F.set(F.find(fromUrl), { updateUrl: false, source: 'url' });
        }

        /* Show categories in the grid bar once this selector scrolls out of view */
        if (this.row && 'IntersectionObserver' in window) {
          this.io = new IntersectionObserver(function (entries) {
            var entry = entries[0];
            var out = !entry.isIntersecting && entry.boundingClientRect.top < 0;
            document.documentElement.classList.toggle('meh-selector-out', out);
          });
          this.io.observe(this.row);
        }
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        if (this.unsub) this.unsub();
        if (this.io) this.io.disconnect();
        document.documentElement.classList.remove('meh-selector-out');
      }
    });
  }

  /* ---------- Grid: shows / hides products ---------- */
  if (!customElements.get('meh-collection-grid')) {
    customElements.define('meh-collection-grid', class extends HTMLElement {
      connectedCallback() {
        var self = this;
        this.items = Array.prototype.slice.call(this.querySelectorAll('[data-meh-item]'));
        this.tiles = Array.prototype.slice.call(this.querySelectorAll('[data-meh-tile]'));
        this.countEl = this.querySelector('[data-meh-count]');
        this.emptyEl = this.querySelector('[data-meh-empty]');
        this.tabsEl = this.querySelector('[data-meh-tabs]');

        this.onTab = function (e) {
          var tab = e.target.closest('[data-meh-tab]');
          if (!tab) return;
          var def = F.find(tab.dataset.key);
          if (!def) return;
          F.set(def, { source: 'bar' });
          if (self.getBoundingClientRect().top < 0) {
            self.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
          }
        };
        if (this.tabsEl) this.tabsEl.addEventListener('click', this.onTab);

        this.unsubDefs = F.onDefs(function (defs) { self.renderTabs(defs); });
        this.unsub = F.subscribe(function (state, opts) { self.apply(state, opts); });
      }

      disconnectedCallback() {
        if (this.tabsEl) this.tabsEl.removeEventListener('click', this.onTab);
        if (this.unsub) this.unsub();
        if (this.unsubDefs) this.unsubDefs();
      }

      renderTabs(defs) {
        if (!this.tabsEl) return;
        this.tabsEl.innerHTML = '';
        if (!defs || defs.length < 2) { this.tabsEl.hidden = true; return; }
        var current = F.state.key;
        var frag = document.createDocumentFragment();
        defs.forEach(function (d) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'meh-cg__tab';
          b.setAttribute('data-meh-tab', '');
          b.dataset.key = d.key;
          b.textContent = d.label;
          b.setAttribute('aria-pressed', String(d.key === current));
          frag.appendChild(b);
        });
        this.tabsEl.appendChild(frag);
        this.tabsEl.hidden = false;
      }

      matches(item, state) {
        if (state.match === 'all' || !state.value) return true;
        if (state.match === 'type') return item.dataset.type === state.value;
        return (' ' + (item.dataset.tags || '') + ' ').indexOf(' ' + state.value + ' ') > -1;
      }

      apply(state, opts) {
        var self = this;
        var visible = 0;
        var animate = !opts.initial && !reduceMotion;

        this.items.forEach(function (item) {
          var ok = self.matches(item, state);
          item.hidden = !ok;
          item.classList.remove('is-entering');
          if (ok) {
            if (animate) {
              item.style.setProperty('--i', visible);
              void item.offsetWidth; /* restart animation */
              item.classList.add('is-entering');
            }
            visible++;
          }
        });

        this.tiles.forEach(function (tile) {
          var show = tile.dataset.show;
          var ok = show === 'always' ? true
            : show === 'category' ? state.key === tile.dataset.showKey
            : state.key === 'all';
          tile.hidden = !ok;
          tile.classList.remove('is-entering');
          if (ok && animate) { void tile.offsetWidth; tile.classList.add('is-entering'); }
        });

        if (this.countEl) this.countEl.textContent = state.key === 'all' ? (this.dataset.total || visible) : visible;
        if (this.emptyEl) this.emptyEl.hidden = visible > 0 || this.items.length === 0;

        if (this.tabsEl) {
          var active = null;
          Array.prototype.forEach.call(this.tabsEl.children, function (b) {
            var on = b.dataset.key === state.key;
            b.setAttribute('aria-pressed', String(on));
            if (on) active = b;
          });
          centerInRow(this.tabsEl, active);
        }
      }
    });
  }
})();
